"use client";

import { useState } from "react";
import Button, { ButtonVariant } from "@/app/(components)/generics/Button/Button";
import { Input } from "@/app/(components)/generics/inputs/default/Input/Input";
import { createZonePreset } from "@/app/actions/zone-preset/action";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { T, TErrors } from "@/app/translations/Translations";
import { ZonePresetConfig } from "@/app/types/ZonePreset";
import styles from "./SaveZonePreset.module.css";

type Props = { lang: string; config: ZonePresetConfig; defaultName: string };

export default function SaveZonePreset(props: Props) {
  const { lang, config, defaultName } = props;

  const { closeModal } = ModalStore();

  const [data, setData] = useState({ name: defaultName });
  const [loading, setLoading] = useState(false);
  const [fieldErrors, setFieldErrors] = useState<{ [key: string]: string }>({});

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setFieldErrors({});

    if (!data.name.trim()) {
      setFieldErrors(TErrors({ name: TKey.ERROR_REQUIRED }, lang));
      return;
    }

    setLoading(true);
    const result = await createZonePreset({ name: data.name, config });
    setLoading(false);

    if (result.success) {
      closeModal();
    } else if (result.fieldErrors) {
      setFieldErrors(TErrors(result.fieldErrors, lang));
    }
  };

  return (
    <form className={styles.container} onSubmit={handleSubmit}>
      <Input
        data={data}
        dataKey="name"
        label={T(TKey.ZONE_NAME, lang) as string}
        lang={lang}
        required
        showRequiredLabel
        placeholder={T(TKey.ZONE_NAME, lang) as string}
        onChange={(d) => setData({ ...d })}
        errorMessage={fieldErrors.name}
      />

      <div className={styles.actions}>
        <Button variant={ButtonVariant.SECONDARY} onClick={closeModal}>
          {T(TKey.CANCEL, lang)}
        </Button>
        <Button variant={ButtonVariant.PRIMARY} type="submit" loading={loading}>
          {T(TKey.SAVE, lang)}
        </Button>
      </div>
    </form>
  );
}
